// Extracted from LandingPage.js (2026-10-21, bundle-size pass) so the
// authenticated app's header can import just the logo mark instead of
// pulling in all of LandingPage.js — that let LandingPage become a
// React.lazy() chunk, since the main app no longer needs anything from it
// synchronously. See App.js's import of LandingPage/AdminApp/etc.
export const ZenLogo = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="zlg1" x1="0" y1="1" x2="0" y2="0">
        <stop offset="0%" stopColor="#0369a1" stopOpacity="0.95"/>
        <stop offset="100%" stopColor="#0284c7" stopOpacity="0.8"/>
      </linearGradient>
      <linearGradient id="zlg2" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#0ea5e9" stopOpacity="0.85"/>
        <stop offset="100%" stopColor="#0369a1" stopOpacity="0.65"/>
      </linearGradient>
      <linearGradient id="zlt1" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#38bdf8" stopOpacity="0.95"/>
        <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.85"/>
      </linearGradient>
      <linearGradient id="zlt2" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#7dd3fc" stopOpacity="0.9"/>
        <stop offset="100%" stopColor="#38bdf8" stopOpacity="0.75"/>
      </linearGradient>
    </defs>
    <polygon points="8,44 28,33 28,55 8,66"  fill="url(#zlg1)" stroke="#38bdf8" strokeWidth="0.7"/>
    <polygon points="28,33 48,44 48,66 28,55" fill="url(#zlg2)" stroke="#38bdf8" strokeWidth="0.7"/>
    <polygon points="8,44 28,33 48,44 28,55"  fill="url(#zlt1)" stroke="#38bdf8" strokeWidth="0.7"/>
    <polygon points="28,22 48,11 68,22 48,33" fill="url(#zlt2)" stroke="#38bdf8" strokeWidth="0.7"/>
    <polygon points="28,22 48,33 48,55 28,44" fill="url(#zlg2)" stroke="#38bdf8" strokeWidth="0.7"/>
    <polygon points="48,11 68,22 68,44 48,33" fill="url(#zlg1)" stroke="#38bdf8" strokeWidth="0.7"/>
    <line x1="28" y1="44" x2="28" y2="22" stroke="#7dd3fc" strokeWidth="0.7" opacity="0.6"/>
    <line x1="8"  y1="44" x2="28" y2="33" stroke="#bae6fd" strokeWidth="0.7" opacity="0.4"/>
    <line x1="28" y1="33" x2="48" y2="44" stroke="#bae6fd" strokeWidth="0.7" opacity="0.4"/>
    <line x1="28" y1="22" x2="48" y2="11" stroke="#bae6fd" strokeWidth="0.7" opacity="0.4"/>
    <line x1="48" y1="11" x2="68" y2="22" stroke="#bae6fd" strokeWidth="0.7" opacity="0.4"/>
  </svg>
);
